import { buildUrl } from '@repo/toolkit/build-url'
import { useNavigator } from '@repo/toolkit/use-navigator'
import InnerBox from '@repo/ui/inner-box'

import { API, constructApiUrl } from '../../../../api/apis.config'
import { Paths } from '../../../../lib/constants/path'
import useTranslate from '../../../../lib/hooks/use-translate'
import { CurrencyEnum } from '../../../../lib/types/enums/common/currency.enum'
import { Activity } from '../../../../lib/types/models/ol/activity/activity'
import { isHostFamilyDayActivity } from '../../../../utils/constants/activity.constants'
import { getActivityColumns } from '../../../../views/ol-personal-space/activities/util'
import DynamicDataTable from '../../../elements/dynamic-table'

type Props = {
  olId: number
  currency: CurrencyEnum
}

const OlActivityListPage = ({ olId, currency }: Props) => {
  const { navigateWithEvent } = useNavigator()
  const { t } = useTranslate()

  return (
    <InnerBox className="rounded-2xl p-0">
      <DynamicDataTable<Activity, null>
        title={'Activités'}
        columns={getActivityColumns(t, currency)}
        allowSearchParam
        onRowClick={(activity, event) => {
          // "Host family day" is a default activity: it has no detail page
          if (isHostFamilyDayActivity(activity)) return
          navigateWithEvent(
            buildUrl(Paths.OL_ACTIVITY_VIEW_PAGE, { id: activity.id, olId: olId }),
            event
          )
        }}
        permissions={{ delete: false }}
        endpoint={constructApiUrl(API.ols.getActivities.url, { olId: olId })}
      />
    </InnerBox>
  )
}

export default OlActivityListPage
